import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class JobStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('JobStatusReference');
  }
}
